<!--
 * @Author: 李鸿润
 * @Date: 2021-08-05 10:51:05
 * @LastEditTime: 2021-08-12 09:12:24
 * @LastEditors: Please set LastEditors
 * @Description: 时间组件，输入小时和分钟转化为分钟
 * @FilePath: \hpss-ui\src\views\crmedical\order\components\aTime.vue
-->
<template>
<div class="content" v-if="disabled">
    <input class="input" maxlength="4" disabled  v-model="hourdisabled"  />
    <span class="text">小时</span>
    <input class="input"   v-model="minutesdisabled" disabled  maxlength="2" />
    <span class="text">分钟</span>
  </div>
  <div class="content" v-else>
    <input class="input" maxlength="4"    v-model="hour"  />
    <span class="text">小时</span>
    <input class="input"   v-model="minutes"  maxlength="2" />
    <span class="text">分钟</span>
  </div>
  
</template>
<script>
export default {
  props: {
    time: {
      type: Number,
      default: 0,
    },
    disabled:{
        type: Boolean,
        default: false,
    }
  },
  data() {
    return {
      hour: '',
      minutes: '',
      hourdisabled:0,
      minutesdisabled:0,
    };
  },
  watch: {
    time(val,oldVal){
      if(val && val!=oldVal){
        this.hourdisabled = Math.floor(Number(val)/60);
        this.minutesdisabled = Number(val) % 60;
        this.hour = Math.floor(Number(val)/60);
        this.minutes = Number(val) % 60;
      }
    },
    hour(val,){
        this.$nextTick(()=>{
          val=val.replace(/^(0+)|[^\d]+/g,'')
        this.hour = val
        
        this.$emit('update', {
        hour: this.hour,
        minutes: this.minutes,
        });
        console.log("小时",this.hour)
        })
    },
    minutes(val,){
      val+=""
      this.$nextTick(()=>{
        val=val.replace(/^(0+)|[^\d]+/g,'')
       if (val > 59) {
          this.minutes = 59;
        //   e.detail.value = 59;
          this.$emit('update', {
            hour: this.hour,
            minutes: this.minutes,
          });
      } else if (val < 0) {
          this.minutes = 0;
          this.$emit('update', {
            hour: this.hour,
            minutes: this.minutes,
          });
    
      } else {
          this.minutes = val;
          this.$emit('update', {
            hour: this.hour,
            minutes: this.minutes,
          });
    }
      })
  },
  computed: {
    hourComputed:{
            get(){
                    this.hour = parseInt(this.time/60);
                    return  parseInt(this.time/60);
            },
    },
    minutesComputed:{
            get(){
                    this.minutes = parseInt(this.time%60);
                    return  parseInt(this.time%60);
            },
    },
  },
  methods: {
   
  },
  }
};
</script>
<style scoped>
.input {
  width: 60px;
  height: 32px;
  margin-right: 10px;
  border: 1px solid #bfbfbf;
  text-align: center;
}
.content {
  display: flex;
  justify-content: space-around;
  min-width: 230px;
  /* align-items: center; */
}
.text {
  margin-right: 10px;
  font-size: 14px;
  color: #bfbfbf;
  /* font-weight: 500; */
}
</style>
